import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurableEditorSettingRemoteDto } from '../../../../../../generated/swagger';
import NumberFormatOptions = Intl.NumberFormatOptions;

@Pipe({
   name: 'numberFormatConverter',
})
export class NumberFormatConverterPipe implements PipeTransform {
   transform(editorSettings: ConfigurableEditorSettingRemoteDto): NumberFormatOptions {
      return {
         useGrouping: editorSettings.showThousandSeparator,
         maximumFractionDigits: editorSettings.showDecimals ? 10 : 0,
         minimumFractionDigits: editorSettings.showDecimals ? 2 : 0,
      };
   }
}
